export enum OfferIds {
  Speak_Starter = "speak-starter",
  Speak_Pro = "speak-pro",
  Speak_Team = "speak-team",
  Speak_Enterprise = "speak-enterprise",
  Speak_Team_v2 = "speak-team-v2",
}

export const LEGACY_OFFER_IDS: readonly OfferIds[] = [
  OfferIds.Speak_Starter,
  OfferIds.Speak_Pro,
  OfferIds.Speak_Team,
];

/** The single subscription offer sold on the pricing page, priced per seat. */
export const PRO_OFFER_ID = OfferIds.Speak_Team_v2;
